import { render } from "./add_dermatology_procedures_modal.vue?vue&type=template&id=52bbd88d&scoped=true"
import script from "./add_dermatology_procedures_modal.vue?vue&type=script&lang=js"
export * from "./add_dermatology_procedures_modal.vue?vue&type=script&lang=js"

import "./add_dermatology_procedures_modal.vue?vue&type=style&index=0&id=52bbd88d&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bbd88d"]])

export default __exports__